import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL

export default {
  //发票-EMS-编辑预览
  editPreview: (data) => apiAxios('post', baseURL + '/invoice.editPreview', data),
  //发票-提交
  invoiceSave: (data) => apiAxios('post', baseURL + '/invoice.save', data),
  //发票-发票初始化
  invoiceDelete: (data) => apiAxios('post', baseURL + '/invoice.delete', data),
  //发票-编辑预览-装箱数据详情界面
  expressFreightList: (data) => apiAxios('post', baseURL + '/invoice.expressFreightList', data),
  //发票-客户售卖平台及店铺截图选项
  shopScreenOptions: (data) => apiAxios('post', baseURL + '/invoice.shopScreenOptions', data),
  //发票-记录已打印
  invoicePrintTimes: (data) => apiAxios('post', baseURL + '/invoice.invoicePrintTimes', data),


  //千速获取数据
  getPorderData: (data) => apiAxios('post', baseURL + '/porder.getPorderData', data),
  // 临时保存数据
  kilospeedRenewal: (data) => apiAxios('post', baseURL + '/porder.kilospeedRenewal', data),

  //千速手动获取物流号
  generateLogistics: (data) => apiAxios('post', baseURL + '/porder.generateLogistics', data),
  //千速手动修改物流单号
  updateLogistics: (data) => apiAxios('post', baseURL + '/porder.updateLogistics', data),
  //千速取消物流单号
  cancelBOrder: (data) => apiAxios('post', baseURL + '/porder.cancelBOrder', data),
  // 千速地址变更匹配
  addressReminder: (data) => apiAxios('post', baseURL + '/porder.addressReminder', data),
  // 千速发票初始化
  invoiceInitialize: (data) => apiAxios('post', baseURL + '/porder.invoiceInitialize', data),
  // 千速下载发票
  invoiceDownload: (data) => apiAxios('post', baseURL + '/download.invoiceDownload', data),

}